export const MAIN_USER_ID = 'MAIN_USER_ID';

export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND';
export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const SUCCESS_SET_APPLICANT = 'SUCCESS_SET_APPLICANT';
export const REQUEST_SET_APPLICANT = 'REQUEST_SET_APPLICANT';
export const SET_FLAGS = 'SET_FLAGS';

//form applicant

export const APPLICANT_FROM_SIGN = 'APPLICANT_FROM_SIGN';
export const APPLICANT_NAME = 'APPLICANT_NAME';
export const APPLICANT_SURNAME = 'APPLICANT_SURNAME';
export const APPLICANT_I_SUBMITTER_TYPE = 'APPLICANT_I_SUBMITTER_TYPE';
export const APPLICANT_GENDER = 'APPLICANT_GENDER';
export const APPLICANT_ISSUED_BY = 'APPLICANT_ISSUED_BY';
export const APPLICANT_DOCUMENT_TYPE = 'APPLICANT_DOCUMENT_TYPE';
export const APPLICANT_TELEPHONE = 'APPLICANT_TELEPHONE';
export const APPLICANT_RNOKPP = 'APPLICANT_RNOKPP';
export const APPLICANT_FATHER_NAME = 'APPLICANT_FATHER_NAME';
export const APPLICANT_NATIONALITY = 'APPLICANT_NATIONALITY';
export const APPLICANT_SERIES = 'APPLICANT_SERIES';
export const APPLICANT_DATE_OF_ISSUE = 'APPLICANT_DATE_OF_ISSUE';
export const APPLICANT_D_DOC_STOP = 'APPLICANT_D_DOC_STOP';
export const APPLICANT_BANK_ID = 'APPLICANT_BANK_ID';
export const APPLICANT_DOCUMENT_NUMBER = 'APPLICANT_DOCUMENT_NUMBER';
export const APPLICANT_BITHDAY_DATE = 'APPLICANT_BITHDAY_DATE';
export const APPLICANT_ID = 'APPLICANT_ID';
export const APPLICANT_RNOKPP_FEATURE = 'APPLICANT_RNOKPP_FEATURE';
export const APPLICANT_I_ADDRESSTYPE = 'APPLICANT_I_ADDRESSTYPE';
export const APPLICANT_I_ADDRESSTYPE_FACT = 'APPLICANT_I_ADDRESSTYPE_FACT';
export const APPLICANT_EMAIL = 'APPLICANT_EMAIL';
export const APPLICANT_I_APPLICANT = 'APPLICANT_I_APPLICANT';

export const APPLICANT_ACT_RECORD_NUMBER = 'APPLICANT_ACT_RECORD_NUMBER';
export const APPLICANT_ACT_RECORD_DATE = 'APPLICANT_ACT_RECORD_DATE';
export const APPLICANT_UNZR_NUMBER = 'APPLICANT_UNZR_NUMBER';

//match address
export const APPLICANT_L_ADDRESSESMATCH = 'APPLICANT_L_ADDRESSESMATCH';
//real address
export const APPLICANT_ID_I_APPLICANT = 'APPLICANT_ID_I_APPLICANT';
export const APPLICANT_ADDRESS_ID = 'APPLICANT_ADDRESS_ID';
export const APPLICANT_C_FLAT = 'APPLICANT_C_FLAT';
export const APPLICANT_C_BUILDING = 'APPLICANT_C_BUILDING';
export const APPLICANT_I_REGION = 'APPLICANT_I_REGION';
export const APPLICANT_C_HOUSING = 'APPLICANT_C_HOUSING';
export const APPLICANT_I_POSTINDEX = 'APPLICANT_I_POSTINDEX';
export const APPLICANT_I_LOCALITY = 'APPLICANT_I_LOCALITY';
export const APPLICANT_I_SUBDIVISION = 'APPLICANT_I_SUBDIVISION';
export const APPLICANT_I_STREET = 'APPLICANT_I_STREET';

//fact address
export const APPLICANT_ID_I_APPLICANT_FACT = 'APPLICANT_ID_I_APPLICANT_FACT';
export const APPLICANT_ADDRESS_ID_FACT = 'APPLICANT_ADDRESS_ID_FACT';
export const APPLICANT_C_FLAT_FACT = 'APPLICANT_C_FLAT_FACT';
export const APPLICANT_C_BUILDING_FACT = 'APPLICANT_C_BUILDING_FACT';
export const APPLICANT_I_REGION_FACT = 'APPLICANT_I_REGION_FACT';
export const APPLICANT_C_HOUSING_FACT = 'APPLICANT_C_HOUSING_FACT';
export const APPLICANT_I_POSTINDEX_FACT = 'APPLICANT_I_POSTINDEX_FACT';
export const APPLICANT_I_LOCALITY_FACT = 'APPLICANT_I_LOCALITY_FACT';
export const APPLICANT_I_SUBDIVISION_FACT = 'APPLICANT_I_SUBDIVISION_FACT';
export const APPLICANT_I_STREET_FACT = 'APPLICANT_I_STREET_FACT';
export const APPLICANT_ADDRESS_CLEAR_FACT_REGION =
  'APPLICANT_ADDRESS_CLEAR_FACT_REGION';
//export const APPLICANT_I_ADDRESSTYPE = "APPLICANT_I_ADDRESSTYPE";

export const APPLICANT_ADDRESS_FACT_CLEAR = 'APPLICANT_ADDRESS_FACT_CLEAR';
export const APPLICANT_DOCUMENT_CLEAR = 'APPLICANT_DOCUMENT_CLEAR';

//bank
export const APPLICANT_P_ACCOUNT = 'APPLICANT_P_ACCOUNT';
export const APPLICANT_P_MFO = 'APPLICANT_P_MFO';
export const APPLICANT_P_EDRPOU = 'APPLICANT_P_EDRPOU';
export const APPLICANT_P_NAME = 'APPLICANT_P_NAME';
export const APPLICANT_P_ID = 'APPLICANT_P_ID';
export const SET_BANKS = 'SET_BANKS';
export const CLEAR_BANK = 'CLEAR_BANK';

//form child
export const CHILD_NAME = 'CHILD_NAME';
export const CHILD_SURNAME = 'CHILD_SURNAME';
export const CHILD_FATHER_NAME = 'CHILD_FATHER_NAME';
export const CHILD_BITHDAY_DATE = 'CHILD_BITHDAY_DATE';
export const CHILD_GENDER = 'CHILD_GENDER';
export const CHILD_FAMILY_RELATION = 'CHILD_FAMILY_RELATION';
export const CHILD_DOCUMENT_TYPE = 'CHILD_DOCUMENT_TYPE';
export const CHILD_SERIES = 'CHILD_SERIES';
export const CHILD_DOCUMENT_NUMBER = 'CHILD_DOCUMENT_NUMBER';
export const CHILD_DATE_OF_ISSUE = 'CHILD_DATE_OF_ISSUE';
export const CHILD_ISSUED_BY = 'CHILD_ISSUED_BY';
export const CHILD_ACT_NUMBER = 'CHILD_ACT_NUMBER';
export const CHILD_ACT_DATE = 'CHILD_ACT_DATE';
export const CHILD_CARE_DATE = 'CHILD_CARE_DATE';
export const SET_CHILD = 'SET_CHILD';
export const CLEAR_CHILD_DATA = 'CLEAR_CHILD_DATA';
export const CHILD_UNZR_NUMBER = 'CHILD_UNZR_NUMBER';
export const CHILD_RNOKPP = 'CHILD_RNOKPP';

//submit child
export const REQUEST_CHILD_DATA = 'REQUEST_CHILD_DATA';
export const SUCCESS_CHILD_DATA = 'SUCCESS_CHILD_DATA';
export const SAVE_CHILD_DATA = 'SAVE_CHILD_DATA';
export const CHANGE_CHILD = 'CHANGE_CHILD';

//childrenTable
export const REQUEST_CHILDREN_DATA = 'REQUEST_CHILDREN_DATA';
export const SUCCESS_CHILDREN_DATA = 'SUCCESS_CHILDREN_DATA';
export const GET_SELECT_CHILDREN = 'GET_SELECT_CHILDREN';
export const SELECT_CHILDREN = 'SELECT_CHILDREN';
export const SUCCESS_CHILDREN_BY_APP_ID = 'SUCCESS_CHILDREN_BY_APP_ID';
export const REQUEST_CHILDREN_BY_APP_ID = 'REQUEST_CHILDREN_BY_APP_ID';

//flags
export const L_SHOW_APPLICANT_TEXT = 'L_SHOW_APPLICANT_TEXT';
export const L_SHOW_APPLICANT_EDIT_CMD = 'L_SHOW_APPLICANT_EDIT_CMD';
export const L_SHOW_APPLICANT_FORM = 'L_SHOW_APPLICANT_FORM';
export const L_SHOW_CHILDREN_TABLE = 'L_SHOW_CHILDREN_TABLE';
export const L_SHOW_CHILDREN_TABLE_EDIT_CMD = 'L_SHOW_CHILDREN_TABLE_EDIT_CMD';
export const L_SHOW_CHILDREN_TABLE_DELETE_CMD =
  'L_SHOW_CHILDREN_TABLE_DELETE_CMD';
export const L_SHOW_CHILDREN_TABLE_ADD_CMD = 'L_SHOW_CHILDREN_TABLE_ADD_CMD';
export const L_SHOW_CHILD_FORM = 'L_SHOW_CHILD_FORM';
export const L_SHOW_APPLICATION_TEXT = 'L_SHOW_APPLICATION_TEXT';
export const L_SHOW_APPLICATION_VIEW_CMD = 'L_SHOW_APPLICATION_VIEW_CMD';
export const L_SHOW_APPLICATION_REFUSE_CMD = 'L_SHOW_APPLICATION_REFUSE_CMD';
export const L_SHOW_APPLICATION_CANCEL_CMD = 'L_SHOW_APPLICATION_CANCEL_CMD';
export const L_SHOW_APPLICATION_CREATE_CMD = 'L_SHOW_APPLICATION_CREATE_CMD';
export const L_SHOW_AGREEMENT_TABLE = 'L_SHOW_AGREEMENT_TABLE';
export const L_SHOW_AGREEMENT_VIEW_CMD = 'L_SHOW_AGREEMENT_VIEW_CMD';
export const L_SHOW_PAYMENT_TABLE_VIEW_CMD = 'L_SHOW_PAYMENT_TABLE_VIEW_CMD';
export const L_SHOW_APPLICATION_SUBMIT_CMD = 'L_SHOW_APPLICATION_SUBMIT_CMD';
export const L_SHOW_PAYMENT_ADD_CMD = 'L_SHOW_PAYMENT_ADD_CMD';
export const L_SHOW_PAYMENT_VIEW_CMD = 'L_SHOW_PAYMENT_VIEW_CMD';

//data from directories
export const REQUEST_DATA_FROM_DIRECTORIES = 'REQUEST_DATA_FROM_DIRECTORIES';
export const SUCCESS_DATA_FROM_DIRECTORIES = 'SUCCESS_DATA_FROM_DIRECTORIES';
export const ERROR_DATA_FROM_DIRECTORIES = 'ERROR_DATA_FROM_DIRECTORIES';
export const SUCCESS_DATA_FROM_DISTRICT = 'SUCCESS_DATA_FROM_DISTRICT';
export const SUCCESS_DATA_FROM_STREET = 'SUCCESS_DATA_FROM_STREET';

//set data for select
export const SET_ADDRESS_TYPE = 'SET_ADDRESS_TYPE';
export const SET_CITIZENSHIP = 'SET_CITIZENSHIP';
export const SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE';
export const SET_GENDER = 'SET_GENDER';

export const SET_RELATION = 'SET_RELATION';
export const SET_REGION = 'SET_REGION';
export const SET_STREET = 'SET_STREET';
//export const SET_DISTRICT = 'SET_DISTRICT'
export const SUCCESS_SET_DISTRICT = 'SUCCESS_SET_DISTRICT';
export const REQUEST_SET_DISTRICT = 'REQUEST_SET_DISTRICT';
//export const SET_CITY = 'SET_CITY'
export const SUCCESS_SET_CITY = 'SUCCESS_SET_CITY';
export const REQUEST_SET_CITY = 'REQUEST_SET_CITY';
export const SET_INDEX = 'SET_INDEX';

export const SET_STREET_FACT = 'SET_STREET_FACT';
export const SUCCESS_SET_DISTRICT_FACT = 'SUCCESS_SET_DISTRICT_FACT';
export const REQUEST_SET_DISTRICT_FACT = 'REQUEST_SET_DISTRICT_FACT';
export const SUCCESS_SET_CITY_FACT = 'SUCCESS_SET_CITY_FACT';
export const REQUEST_SET_CITY_FACT = 'REQUEST_SET_CITY_FACT';
export const SET_INDEX_FACT = 'SET_INDEX_FACT';

export const CLEAR_INDEX_AND_DISTRICT = 'CLEAR_INDEX_AND_DISTRICT';
export const CLEAR_CITY_STREET_BANKS = 'CLEAR_CITY_STREET_BANKS';
export const CLEAR_INDEX_AND_DISTRICT_FACT = 'CLEAR_INDEX_AND_DISTRICT_FACT';
export const CLEAR_CITY_STREET_BANKS_FACT = 'CLEAR_CITY_STREET_BANKS_FACT';

//children document

export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAIL = 'UPLOAD_DOCUMENT_FAIL';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';

//Application

export const APPLICATION_ID = 'APPLICATION_ID';
export const INITIAL_APP_ID = 'INITIAL_APP_ID';
export const SUCCESS_APPLICATION_LIST = 'SUCCESS_APPLICATION_LIST';
export const REQUEST_APPLICATION_LIST = 'REQUEST_APPLICATION_LIST';
export const SET_AGRIMANT = 'SET_AGRIMANT';
export const GET_AGRIMANT = 'GET_AGRIMANT';
export const GET_PAYMANT = 'GET_PAYMANT';
export const SET_PAYMANT = 'SET_PAYMANT';

export const IS_IDLE = 'IS_IDLE';

export const IIT_ECP = 'IIT_ECP';

export const SUCCESS_DOC_FILES = 'SUCCESS_DOC_FILES';
export const APPLICANT_CLEAR = 'APPLICANT_CLEAR';
export const SET_RNOKPP = 'SET_RNOKPP';
export const SET_APPLICATION_FLAGS = 'SET_APPLICATION_FLAGS';
export const DISABLEMENT = 'DISABLEMENT';
export const STATE_REGISTARTION_2020 = 'STATE_REGISTARTION_2020';
